import type { FieldPath, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { FormProps } from '@/hooks/useZodForm';
import { CheckboxGroup, type CheckboxGroupProps } from '../CheckboxGroup';
import { FieldLabel } from './FieldLabel';

type FormCheckboxGroupProps<TData extends FieldValues, TValue extends string | number> = Omit<
  CheckboxGroupProps<TValue>,
  'value' | 'onChange'
> & {
  label: string;
  fieldName: FieldPath<TData>;
  formProps: FormProps<TData>;
};

export function FormCheckboxGroup<TData extends FieldValues, TValue extends string | number>(
  props: FormCheckboxGroupProps<TData, TValue>
) {
  const { label, fieldName, formProps, ...checkboxGroupProps } = props;
  const { control, errors } = formProps;
  const error = errors[fieldName]?.message as string | undefined;

  return (
    <FieldLabel label={label} error={error}>
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => {
          const value = Array.isArray(field.value) ? field.value : [];
          return (
            <CheckboxGroup
              value={value}
              onChange={(v) => field.onChange(v)}
              {...checkboxGroupProps}
            />
          );
        }}
      />
    </FieldLabel>
  );
}
